import React from 'react'
import Header from "../Component/Header";
import Footer from "../Component/Footer"; 
import { Link } from 'react-router-dom'
const SchoolParliament = () => {
    var myfun = function(ele){
        let offsetTop  = document.getElementById(ele).offsetTop;
        var right = document.getElementById("#right");
        window.scrollTo({
            top: offsetTop-100, 
            behavior: "smooth"
        });
    }
   return (
    <>
<Header/>   <div className="inner_slider">
   <img src="Images/inner_slider.jpg" className="img-fluid inner_slider_img" alt="St. Xaviers Bathinda"/> 
   <div className="row bread_cumb">
   <h2>School Parliament </h2>
   <div className="theme-heading">
   <span className="colorW marB10"><i className="bi bi-building"></i></span>
   </div>
   <h5><Link to="/">Home <i className="bi bi-arrow-right"></i> </Link><span>  Office Bearers  <i className="bi bi-arrow-right"></i> School Parliament </span></h5>
   </div>
   </div>
   <div className="innerpage">
   <div className="row inner_cont schoolparliament">
   <ul className="linktosec">
   <li><button onClick={() => myfun('div2')}>Senior Cabinet</button></li>
   <li><button onClick={() => myfun('div8')}>Junior Cabinet</button></li>
   </ul>
   <div className="col-lg-12 col-md-12 col-sm-12 col-12 cabintes_sec">
   <h2>Formal Address by Office Bearers</h2>
   <div id="right" className="right">
   <div className="sx_msg_sec" id="div2">
   <div className="row">
   <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/GULNOOR-KAUR-GILL-XIE-PM.JPG" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <p>It wasn't until the very moment when the tears reached the corners of my eyes that I felt the true value of the post that I'd been bestowed upon and was about to enter. I was very unsure in the beginning as I was a new student to this institution and didn't know much, however it was the management and my peers standing beside me that made me respect and realize the true responsibility of this post. Therefore, it was with immense pride that I happily accepted both the pros and cons this post brought. Nonetheless I've always been very thankful to the school authorities who found me capable of this post and handed me this precious responsibility within the first week I joined.</p>
   <p>As it is rightly said by Warren G. Bennis, “leadership is the capacity to translate vision into reality ", I along with my team shall be working to the best of our abilities to translate the vision our founders saw while laying the foot stone of this school and turn it into reality one fine day.</p>
   <p><strong>Gulnoor Kaur Gill</strong></p>
   <p><strong>(Prime Minister – XI E)</strong></p>
   <div className="clr"></div>
   </article>
   </div>
   <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/SHUBHDEEP-SINGH-XIE-DPM.JPG" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <p>I, Shubhdeep Singh, as the Deputy Prime Minister of the School's parliament, would like to extend my sincere vote of thanks to Fr. Principal, all the teachers and students who have entrusted me with this position. Leadership, in its essence, embodies the ability to guide and inspire others towards a common goal. It involves fostering a sense of unity, encouraging collaboration, and leading by example. However, amidst the responsibilities of leadership, it is crucial to always remember the value of humbleness. Humility allows us to listen, learn, and empathize with others, fostering a culture of inclusivity and respect. Together, let us embrace the spirit of leadership with humility and work towards a better future for our school community.</p>
   <p><strong>Shubhdeep Singh</strong></p>
   <p><strong>(Deputy Prime Minister – XI E)</strong></p>
   <div className="clr"></div>
   </article>
   </div>
   <div className="col-lg-12col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/JOTSAROOP-KAUR-BHASIN- IXC-HEAD GIRL.JPG" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <p><b>“LEADERSHIP IS ABOUT MAKING OTHERS BETTER AS A RESULT OF YOUR PRESENCE AND MAKING SURE THAT THE IMPACT LASTS IN YOUR ABSENCE.”</b></p>
   <p>My alma mater - St. Xavier’s School, Bathinda has been a distinguished institution for swotting and developing my inner self, boosting my confidence, thereby guiding me towards a brighter future. With the blessings of the almighty, I feel exceedingly blessed to have been appointed as the Head Girl of this prestigious institution. I express my sincere gratitude to our worthy Principal Rev. Fr. Cidloy Furtado and all the faculty members who have reposed their confidence in us for this session’s student council. I vow to discharge my duty with morality and earnestness and will encourage all the students to achieve brilliance diligently, be it in academics or co-curricular activities thereby helping our school become an exemplification of calibre and distinction. I promise to uphold my allegiance to the tradition and ethics of the school and shall also try to establish and inculcate a fond affinity amongst everyone.</p>
   <p><strong>Jotsaroop Kaur Bhasin</strong></p>
   <p><strong>(Head Girl – IX C)</strong></p>
   <div className="clr"></div>
   </article>
   </div>
   <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/MANRAJ-SINGH-SANDHU-IXC-HEAD BOY.JPG" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <p><b>“We know we are firm. I know, and I affirm that at the core of our being, of my being, there is the fact of responsibility.”</b></p>
   <p>It is evident that allegiance and responsibilities do not end with the election of leaders, but instead make a new beginning. In order to dig the layers for optimal discipline and talent, one has to unravel the need to put one’s heart and soul into one’s duties and responsibilities. It is consequently a great honour for me, the Head Boy of this bona fide institution, to have been entrusted with this Brobdingnagian responsibility for the year 2023-24. My overwhelming and unfeigned gratitude goes to Rev. Fr. Cidloy Furtado, Principal St. Xavier’s, the entire management and also to all the staff members. I acknowledge that leadership is not a path to privilege, it is but a responsibility; it is not an assertion of control over others – but the sincere desire to serve. I will deliver what I promise, without compromise. Along with our newly elected school parliament members, I will be ever ready with my armor on, to render my honest service to the school, and will leave no space for disappointments. It is coherent that my role demands dedication, organization, confidence and sacrifice which is why my constant endeavor will be to do justice to my eminent position and bring laurels to the school at all levels. I pray for God’s rich blessings on every member of the Xavierite family.</p>
   <p><strong>Manraj Singh Sandhu</strong></p>
   <p><strong>(Head Boy – IX C)</strong></p>
   <div className="clr"></div>
   </article>
   </div>
   
   
   </div>
   <div className="clr"></div>
   </div>
   <div className="cabi_2022 clr_1_cabi">
   <center><h2>Core Parliament </h2></center>
   <div className="row">
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/GULNOOR-KAUR-GILL-XIE-PM.JPG"  alt="St. Xavies Bathinda" /><h3>PRIME MINISTER </h3><h4>GULNOOR KAUR GILL - XI E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/SHUBHDEEP-SINGH-XIE-DPM.JPG"  alt="St. Xavies Bathinda" /><h3>DEPUTY PRIME MINISTER </h3><h4>SHUBHDEEP SINGH - XI E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/AKSHITA-XI-E-Speaker.JPG"  alt="St. Xavies Bathinda" /><h3>SPEAKER </h3><h4>AKSHITA  -  XI E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/MANTAJBIR SINGH-XI E-DEPUTY SPEAKER.jpg"  alt="St. Xavies Bathinda" /><h3>DEPUTY SPEAKER </h3><h4>MANTAJBIR SINGH - XI E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/ANHAD KAUR - XI E - GENRAL SECRETARY.JPG"  alt="St. Xavies Bathinda" /><h3>GENERAL SECRETARY </h3><h4>ANHAD KAUR  - XI E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
            <img src="Images/JHANVI - XI C -GENERAL SECRETARY.JPG"  alt="St. Xavies Bathinda" /><h3>GENERAL SECRETARY </h3><h4>JHANVI - XI C </h4>
        </article>
    </div>
   </div>
   </div>
   <div className="cabi_2022 clr_2_cabi">
   <center><h2>Editorial Board</h2></center>
   <div className="row">
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
           <img src="Images/SUKRITI MITTAL - XI E - EDITORIAL BOARD (ENGLISH).JPG"  alt="St. Xavies Bathinda" /><h3>EDITORIAL BOARD (ENGLISH) </h3><h4>SUKRITI MITTAL - XI E</h4>
       </article>
   </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
           <img src="Images/BHAVYA BAGARIA - XI B -EDITORIAL BOARD (HINDI).JPG"  alt="St. Xavies Bathinda" /><h3>EDITORIAL BOARD (HINDI) </h3><h4>BHAVYA BAGARIA  - XI B</h4>
       </article>
   </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
           <img src="Images/KHUSHNOOR KAUR - XI E -EDITORIAL BOARD (PUNJABI).JPG"  alt="St. Xavies Bathinda" /><h3>EDITORIAL BOARD (PUNJABI) </h3><h4>KHUSHNOOR KAUR - XI E</h4>
       </article>
   </div>
   </div>
   </div>
   <div className="cabi_2022 clr_3_cabi">
   <center><h2>School Parliament</h2></center>
   <div className="row">
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/1.JOTSAROOP KAUR BHASIN - IX C - HEAD GIRL.JPG"  alt="St. Xavies Bathinda" />
            <h3>HEAD GIRL </h3><h4>JOTSAROOP KAUR BHASIN - IX C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/2.MANRAJ SINGH SANDHU - IX C - HEAD BOY.JPG"  alt="St. Xavies Bathinda" />
            <h3>HEAD BOY</h3><h4>MANRAJ SINGH SANDHU - IX C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/3.ARMAANDEEP SINGH SIDHU - IX D - MINISTER OF CULTURAL AFFAIRS.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF CULTURAL AFFAIRS </h3><h4>ARMAANDEEP SINGH SIDHU - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/4. SAKSHAM GARG - VIII C - DEPUTY MINISTER OF CULTURAL AFFAIRS.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF CULTURAL AFFAIRS </h3><h4>SAKSHAM GARG - VIII C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/5. PARUL VASON - IX D - MINISTRY OF CULTURAL AFFAIRS (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF CULTURAL AFFAIRS (SECRETARY) </h3><h4>PARUL VASON - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/6. SEHAJ SHARMA - VIII A - MINISTRY OF CULTURAL AFFAIRS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF CULTURAL AFFAIRS (MEMBER) </h3><h4>SEHAJ SHARMA - VIII A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/7.DEVANSH MONGA - IX C - MINISTER OF EDUCATION.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF EDUCATION </h3><h4>DEVANSH MONGA - IX C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/8.GARIMA GUPTA - VIII B - DEPUTY MINISTER OF EDUCATION.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF EDUCATION</h3><h4>GARIMA GUPTA - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/9.PRATIBHA CHAUHAN - IX D - MINISTRY OF EDUCATION (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3> MINISTRY OF EDUCATION (MEMBER)</h3><h4>PRATIBHA CHAUHAN - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/10.SUMONA - IX D - MINISTRY OF EDUCATION (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF EDUCATION (MEMBER)</h3><h4>SUMONA - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/11.RUPAM - VIII D - MINISTRY OF EDUCATION (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF EDUCATION (MEMBER) </h3><h4>RUPAM - VIII D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/12.CHANDVI SINGLA  - IX A - MINSTER OF ENVIRONMENT.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF ENVIRONMENT </h3><h4>CHANDVI SINGLA  - IX A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/13.KHUSHI GARG - IX D -DEPUTY MINISTER OF ENVIRONMENT.jpg"  alt="St. Xavies Bathinda" />
            <h3> DEPUTY MINISTER OF ENVIRONMENT </h3><h4>KHUSHI GARG - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/14.HARJAS SINGH WALIA - VIII B - MINISTRY OF ENVIRONMENT (SECERATARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF ENVIRONMENT (SECRETARY) </h3><h4>HARJAS SINGH WALIA - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/15.SIDDHANT BANSAL - VIII A - MINISTRY OF ENVIRONMENT (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF ENVIRONMENT (MEMBER) </h3><h4>SIDDHANT BANSAL - VIII A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/16.HARLEEN KAUR - IX C - MINSTER OF EXTERNAL AFFAIRS.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINSTER OF EXTERNAL AFFAIRS</h3><h4>HARLEEN KAUR - IX C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/17.SHUBHDEEP KAUR - VIII D - DEPUTY MINISTER OF EXTERNAL AFFAIRS.jpg"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF EXTERNAL AFFAIRS</h3><h4>SHUBHDEEP KAUR - VIII D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/18.HARSIMRAT KAUR - VIII B - MINISTRY OF EXTERNAL AFFAIRS (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF EXTERNAL AFFAIRS (SECRETARY)</h3><h4>HARSIMRAT KAUR - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/19.DIVYAM MARWAHA - VIII C - MINISTRY OF EXTERNAL AFAIRS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF EXTERNAL AFAIRS (MEMBER)</h3><h4>DIVYAM MARWAHA - VIII C </h4>
        </article>
    </div>
   
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/20.SEERAT KAUR SIDHU - IX D -MINISTER OF FINANCE.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF FINANCE </h3><h4>SEERAT KAUR SIDHU - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/21.AARAV BANSAL - VIII A - DEPUTY MINISTER OF FINANCE.jpg"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF FINANCE </h3><h4>AARAV BANSAL - VIII A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/22. KNEESHA - IX A - MINISTRY OF FINANCE (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF FINANCE (SECRETARY) </h3><h4>KNEESHA - IX A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/23. DIGVIJAY SINGH MANN - IX D - MINISTRY OF FINANCE (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF FINANCE (MEMBER)</h3><h4>DIGVIJAY SINGH MANN - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/24.TARANJOT KAUR MAKKAR - VIII E - MINISTRY OF FINANCE (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF FINANCE (MEMBER)</h3><h4>TARANJOT KAUR MAKKAR - VIII E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/25.JANNAT - IX D - MINISTER OF HEALTH.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF HEALTH</h3><h4>JANNAT - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/26.CHARVI BAJAJ - VIII A - DEPUTY MINISTER OF HEALTH.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF HEALTH</h3><h4>CHARVI BAJAJ - VIII A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/27. SHRISHTI MITTAL - IX C - MINISTRY OF HEALTH (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF HEALTH (SECRETARY)</h3><h4>SHRISHTI MITTAL - IX C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/28.SIYA RANI - VIII A - MINISTRY OF HEALTH (MEMBER).jpg"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF HEALTH (MEMBER)</h3><h4>SIYA RANI - VIII A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/29.SHAURYA PURI - IX E - MINISTER OF HOME AFFAIRS.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF HOME AFFAIRS</h3><h4>SHAURYA PURI - IX E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/30.RIDHIKA GUPTA - VIII C - DEPUTY MINISTER OF HOME AFFAIRS.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF HOME AFFAIRS</h3><h4>RIDHIKA GUPTA - VIII C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/31.ANSHAM GARG - VIII B - MINISTRY OF HOME AFFAIRS (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF HOME AFFAIRS (SECRETARY)</h3><h4>ANSHAM GARG - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/32.KASHVI GOYAL - IX E - MINISTRY OF HOME AFFAIRS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF HOME AFFAIRS (MEMBER)</h3><h4>KASHVI GOYAL - IX E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/33.MANTESHWAR SINGH BRAR - VIII E - MINISTRY OF HOME AFFAIRS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF HOME AFFAIRS (MEMBER)</h3><h4>MANTESHWAR SINGH BRAR - VIII E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/34. REVANSHI BALDI - IX D - MINISTER OF I.T.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF I.T</h3><h4>REVANSHI BALDI - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/35.KHUSHIV BATRA - VIII D - DEPUTY MINISTER OF I.T.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF I.T</h3><h4>KHUSHIV BATRA - VIII D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/36.SARGUN SIDHU - VIII C - MINISTRY OF I.T (SECRETARY).jpg"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF I.T (SECRETARY) </h3><h4>SARGUN SIDHU - VIII C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/37.PRABHDEEP - VIII A - MINISTRY OF I.T (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF I.T (MEMBER)</h3><h4>PRABHDEEP - VIII A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/38.RISHAV JINDAL - VIII E - MINISTRY OF I.T (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF I.T (MEMBER)</h3><h4>RISHAV JINDAL - VIII E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/39.PARIDHI -IX A - MINISTER OF INNOVATION.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF INNOVATION </h3><h4>PARIDHI -IX A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/40.ISHMEET KAUR - VIII C - DEPUTY MINISTER OF INNOVATION.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF INNOVATION </h3><h4>ISHMEET KAUR - VIII C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/41.YOSHITA - IX A - MINISTRY OF INNOVATION (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF INNOVATION (SECRETARY)  </h3><h4>YOSHITA - IX A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/42.KRITTIKA GARG -IX A - MINISTRY OF INNOVATION (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF INNOVATION (MEMBER) </h3><h4>KRITTIKA GARG -IX A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/43.MANNAT SIDHU - IX D - MINISTRY OF INNOVATION (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF INNOVATION (MEMBER) </h3><h4>MANNAT SIDHU - IX D</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/44.TISHA - IX C - MINISTER OF SI.G.JPG"  alt="St. Xavies Bathinda" />
            <h3> MINISTER OF SI.G</h3><h4>TISHA - IX C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/45.CHAVI GOYAL -VIII B - DEPUTY MINISTER OF S.I.G.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF S.I.G </h3><h4>CHAVI GOYAL -VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/46.SKANISHKA GARG - IX A - MINISTRY OF S.I.G (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF S.I.G (SECRETARY)</h3><h4>SKANISHKA GARG - IX A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/47.PRAPTI -VIII A - MINISTRY OF S.I.G (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF S.I.G (MEMBER)</h3><h4>PRAPTI -VIII A </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/48.MANNAT - IX B - MINISTER OF SOCIAL WELFARE.jpg"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF SOCIAL WELFARE</h3><h4>MANNAT - IX B </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/49.CAVLEEN SAPPAL - VIII E - DEPUTY MINISTER OF SOCIAL WELFARE.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF SOCIAL WELFARE</h3><h4>CAVLEEN SAPPAL - VIII E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/50.ANMOLDEEP SINGH - IX E - MINISTRY OF SOCIAL WELFARE (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SOCIAL WELFARE (SECRETARY)</h3><h4>ANMOLDEEP SINGH - IX E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/51.MANNAT - IX D -  MINISTRY OF SOCIAL WELFARE (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SOCIAL WELFARE (MEMBER) </h3><h4>MANNAT - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/52.HARRAJ SINGH BRAR -IX E - MINISTER OF SPORTS.JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTER OF SPORTS</h3><h4>HARRAJ SINGH BRAR -IX E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/53.PRABHDEEP SINGH DHILLON - VIII B -DEPUTY MINISTER OF SPORTS.JPG"  alt="St. Xavies Bathinda" />
            <h3>DEPUTY MINISTER OF SPORTS </h3><h4>PRABHDEEP SINGH DHILLON - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/54.AVNEET KAUR BRAR -IX E - MINISTRY OF SPORTS (SECRETARY).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SPORTS (SECRETARY)</h3><h4>AVNEET KAUR BRAR -IX E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/55.SHUBHNEET SINGH SIDHU - IX B - MINISTRY OF SPORTS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SPORTS (MEMBER) </h3><h4>SHUBHNEET SINGH SIDHU - IX B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/56.AKSHAT GARG - VIII A - MINISTRY OF SPORTS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SPORTS (MEMBER) </h3><h4>AKSHAT GARG - VIII A</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/57.JAIVEEN KAUR SIDHU - VIII C - MINISTRY OF SPORTS (MEMBER).JPG"  alt="St. Xavies Bathinda" />
            <h3>MINISTRY OF SPORTS (MEMBER) </h3><h4>JAIVEEN KAUR SIDHU - VIII C</h4>
        </article>
    </div>
   </div>
   </div>
   <div className="cabi_2022 clr_5_cabi">
   <center><h2>School Cabinet</h2></center>
   <div className="row">
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/1.NAVREEN KAUR - IX C - EMERALD HOUSE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>EMERALD HOUSE CAPTAIN </h3><h4>NAVREEN KAUR - IX C </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/2.KHUSHMEEN KAUR - IX D - RUBY HOUSE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>RUBY HOUSE CAPTAIN </h3><h4>KHUSHMEEN KAUR - IX D </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/3.JIYA GOYAL - IX C - SAPPHIRE HOUSE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>SAPPHIRE HOUSE CAPTAIN </h3><h4>JIYA GOYAL - IX C</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/4.SHIVDEEP KAUR - IX E - TOPAZ HOUSE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>TOPAZ HOUSE CAPTAIN </h3><h4>SHIVDEEP KAUR - IX E </h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/5.RAGHAV GARG - VIII B - EMERALD HOUSE VICE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>EMERALD HOUSE VICE CAPTAIN </h3><h4>RAGHAV GARG - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/6.TVISHA SHARMA - VIII B - RUBY HOUSE VICE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>RUBY HOUSE VICE CAPTAIN </h3><h4>TVISHA SHARMA - VIII B</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/7.BHOOMI CHHABRA - VIII E - SAPPHIRE HOUSE VICE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>SAPPHIRE HOUSE VICE CAPTAIN </h3><h4>BHOOMI CHHABRA - VIII E</h4>
        </article>
    </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
        <article><img src="Images/8.DIVISHA JAURA - VIII D - TOPAZ HOUSE VICE CAPTAIN.JPG"  alt="St. Xavies Bathinda" />
            <h3>TOPAZ HOUSE VICE CAPTAIN </h3><h4>DIVISHA JAURA - VIII D</h4>
        </article>
    </div>
   </div>
   </div>

   <div className="cabi_2022 clr_5_cabi" id="div8">
   <center><h2>Junior School Cabinet</h2></center>
  <div className="row">
   <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/Meer Malhotra-HeadBoy.jpg" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <h3>Message By Head Boy</h3>
   <p>  Being the head boy at St Xavier's School requires a lot of hard work, persistence and gratitude and that's exactly what motivates me even more.  With the help and cooperation of school authorities, teachers and my counterparts, I assure you that I will be able to live up to everyone's expectations not just today but throughout the year. Leaving no stone unturned, I will work hard to set a milestone for others to be followed in the years to come.</p>
   
   <p><strong> Meer Malhotra - III D</strong></p>
   <p><strong> Junior Head Boy</strong></p>
   
   <div className="clr"></div>
   </article>
   </div>
   
   <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
   <article>
   <img src="Images/Amayra - Head Girl.jpg" alt="St. Xavier’s School Bathinda" className="sxumn_2021_msg img-fluid"/>
   <h3>Message By Head Girl</h3>
   <p> Being a leader, I assure you all to put best of my knowledge, hard-work and perseverance for the betterment of the students in order to keep our school in high spirits always. I will also make sure that I help all my friends in this school to unleash their hidden abilities to achieve their goals.</p>
   
   <p><strong>Amayra - III E   </strong></p>
   <p><strong>Junior Head Girl</strong></p>
   <div className="clr"></div>
   </article>
   </div>
   </div>
   
   <div className="row">
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/Meer Malhotra-HeadBoy.jpg"  alt="St. Xavies Bathinda" />
   <h3>Junior Head Boy </h3>
   <h4> Meer Malhotra - III D </h4>
   </article>
   </div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/Amayra - Head Girl.jpg"  alt="St. Xavies Bathinda" />
   <h3>Junior Head Girl</h3>
   <h4>Amayra - III E </h4>
   </article>
   </div>
   
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/EMERALDHOUSE-CAPTAIN.jpg"  alt="St. Xavies Bathinda" />
   
   <h3>Captain  - Emerald House </h3>
   <h4>Gurjot Singh - III E   </h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article><img src="Images/EmeraldHouse-ViceCaptain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Vice Captain - Emerald House </h3>
   <h4>Arshiya - III C</h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article><img src="Images/RubyHouse-Captain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Captain - Ruby House </h3>
   <h4>Mannatveer Kaur Sidhu - III D  </h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article><img src="Images/RubyHouse-viceCaptain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Vice Captain -Ruby House</h3>
   <h4>Mahir Goyal - III A  </h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/SapphireHouse-Captain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Captain - Sapphire House</h3>
   <h4>Kiratbir Kaur   - III C</h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/SapphireHouse-ViceCaptain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Vice Captain - Sapphire House </h3>
   <h4>Mitansh Garg  - III B </h4>
   </article></div>
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/TopazHouse-Captain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Captain - Topaz House</h3>
   <h4>Pranavi Arora - III E</h4>
   </article></div>  
   
   
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
   <article>
   <img src="Images/TopazHouse-ViceCaptain.jpg"  alt="St. Xavies Bathinda" />
   <h3>Vice Captain - Topaz House </h3>
   <h4>Shanaya Nagpal - III D </h4>
   </article></div> 
   </div> 
   </div>
   </div>
</div>
</div>
</div> 
 <Footer/>
  </>
  )
}

export default SchoolParliament
